import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Whatsapp from "./Whatsapp";
import "../css/FeaturedProperties.css";

// Define the slug converter function correctly
const toSlug = (text) =>
  text.toString().trim().toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9\-]/g, "");

const ProjectPage = () => {
  const { slug } = useParams();
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryName, setCategoryName] = useState('');
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const res = await fetch("https://adinathbuilder.com/admin/api/project/category");
        const catData = await res.json();

        if (catData.status && Array.isArray(catData.data)) {
          const matched = catData.data.find(cat => toSlug(cat.name) === slug);

          if (matched) {
            setCategoryName(matched.name);
            const projRes = await fetch(`https://adinathbuilder.com/admin/api/projects?category_id=${matched.id}`);
            const projData = await projRes.json();

            if (projData.status && Array.isArray(projData.data) && projData.data.length > 0) {
              setProjects(projData.data);
              setNotFound(false);
            } else {
              setProjects([]);
              setNotFound(true);
            }
          } else {
            setProjects([]);
            setNotFound(true);
          }
        } else {
          setNotFound(true);
        }
      } catch (err) {
        console.error("Fetch error:", err);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [slug]);

  return (
    <>
      <Navbar />
      <br /><br />
      <div className="style-Fs">
        <h5>
          PROJECTS UNDER <span style={{ color: 'red' }}>{categoryName || slug.replace(/-/g, ' ').toUpperCase()}</span>
        </h5>
      </div>

      <div className="container-A py-3 px-4">
        {loading ? (
          <div className="text-center mt-5">Loading...</div>
        ) : notFound ? (
          <div className="text-center mt-5 text-danger">
            <h4>No Projects Found</h4>
            <p>Currently there are no projects available under this category.</p>
            <Link to="/" className="btn btn-outline-dark mt-3">Back to Home</Link>
          </div>
        ) : (
          <div className="row text-start">
            {projects.map((project, index) => (
              <div key={index} className="col-lg-6 col-md-6 mb-4 d-flex">
                <div className="card-A w-100">
                  <img
                    src={project.image_url}
                    className="card-img-top"
                    alt={project.name}
                    style={{
                      height: "420px",
                      width: "100%",
                      objectFit: "cover",
                      padding: "0",
                      backgroundColor: "#f8f8f8",
                    }}
                  />
                  <div className="card-body d-flex flex-column">
                    <h3 className="text-start"><b>{project.name}</b></h3>
                    <p>{project.overview?.slice(0, 100)}...</p>
                    <div className="mt-auto">
                      <Link to={`/project-details/${toSlug(project.name)}?category_id=${project.category_id}&project_id=${project.id}`}>
                        <div className="item text-start bg-dark">More Details</div>
                      </Link>

                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <Whatsapp />
      <Footer />
    </>
  );
};

export default ProjectPage;
